/* =============================================================================
 * Copyright (c) 2026 SKYXOPS Corp. All rights reserved.
 * ============================================================================= */
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { getToken } from './api';

const ENDPOINT = '/api/v1/launcher/web-vitals';

function send(metric: Metric) {
  const body = JSON.stringify({
    route: window.location.pathname || '/',
    metrics: [
      {
        name: metric.name,
        value: Math.round(metric.value * 1000) / 1000,
        navigation_type: metric.navigationType ?? null,
      },
    ],
  });

  const token = getToken();
  if (!token && navigator.sendBeacon) {
    try {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(ENDPOINT, blob);
      return;
    } catch {
      /* fall through */
    }
  }

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  fetch(ENDPOINT, {
    method: 'POST',
    headers,
    body,
    keepalive: true,
  }).catch(() => {
    /* swallow — best-effort */
  });
}

let started = false;

export function startWebVitalsReporter() {
  if (started) return;
  started = true;
  onCLS(send);
  onFCP(send);
  onINP(send);
  onLCP(send);
  onTTFB(send);
}
